(function () {
  var $ = function (s, ctx) { return (ctx || document).querySelector(s); };
  var $$ = function (s, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(s)); };

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', maximumFractionDigits: 2 }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* ---------------- Collection filter + search ---------------- */
  var grid = document.getElementById('products');
  if (grid) {
    var filter = 'All';
    var cards = $$('[data-product-card]', grid);
    var search = document.getElementById('search');
    var resultCount = document.getElementById('result-count');
    var empty = document.getElementById('empty');

    var applyFilter = function () {
      var q = ((search && search.value) || '').trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (card) {
        var matchesCategory = filter === 'All' || card.dataset.category === filter;
        var matchesSearch = !q || (card.dataset.search || '').indexOf(q) !== -1;
        var visible = matchesCategory && matchesSearch;
        card.hidden = !visible;
        if (visible) shown++;
      });
      if (resultCount) resultCount.textContent = shown + ' PIECES';
      if (empty) empty.hidden = shown > 0;
      $$('[data-filter]').forEach(function (b) {
        var active = b.dataset.filter === filter;
        b.classList.toggle('active', active);
        b.setAttribute('aria-pressed', String(active));
      });
    };

    document.addEventListener('click', function (e) {
      var f = e.target.closest('[data-filter]');
      if (f) { filter = f.dataset.filter; applyFilter(); }
      var cat = e.target.closest('[data-category]');
      if (cat && cat.dataset.category) {
        filter = cat.dataset.category;
        if (search) search.value = '';
        applyFilter();
      }
    });
    if (search) search.addEventListener('input', applyFilter);
    var searchClear = document.getElementById('search-clear');
    if (searchClear) searchClear.addEventListener('click', function () {
      if (search) search.value = '';
      filter = 'All';
      applyFilter();
    });
    applyFilter();
  }

  var searchToggle = document.getElementById('search-toggle');
  var searchArea = document.getElementById('search-area');
  if (searchToggle && searchArea) {
    searchToggle.addEventListener('click', function () {
      searchArea.hidden = false;
      var coll = document.getElementById('collection');
      if (coll) coll.scrollIntoView();
      var input = document.getElementById('search');
      if (input) input.focus({ preventScroll: true });
    });
  }

  /* ---------------- Bag / real Shopify cart ---------------- */
  function renderBag(cart) {
    var count = document.getElementById('bag-count');
    if (count) count.textContent = cart.item_count;

    var area = document.getElementById('bag-items');
    var emptyNote = document.getElementById('bag-empty-note');
    if (!area) return;

    while (area.firstChild) area.removeChild(area.firstChild);

    if (!cart.items.length) {
      if (emptyNote) emptyNote.hidden = false;
      return;
    }
    if (emptyNote) emptyNote.hidden = true;

    cart.items.forEach(function (item) {
      var row = document.createElement('div');
      row.className = 'bag-row';

      var img = document.createElement('img');
      img.src = item.image || '';
      img.alt = item.product_title;

      var text = document.createElement('div');
      var title = document.createElement('span');
      title.textContent = item.product_title;
      var detail = document.createElement('p');
      detail.textContent = (item.variant_title || '') + ' · ' + money(item.final_price, cart.currency);

      var remove = document.createElement('button');
      remove.type = 'button';
      remove.textContent = 'REMOVE';
      remove.dataset.removeKey = item.key;

      text.appendChild(title);
      text.appendChild(detail);
      row.appendChild(img);
      row.appendChild(text);
      row.appendChild(remove);
      area.appendChild(row);
    });

    var total = document.createElement('p');
    total.className = 'bag-subtotal';
    total.textContent = 'SUBTOTAL · ' + money(cart.total_price, cart.currency);
    area.appendChild(total);
  }

  function fetchCart() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderBag)
      .catch(function () {});
  }

  function addToCart(id) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add-failed');
      return r.json();
    });
  }

  function changeCart(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); });
  }

  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('visible');
    setTimeout(function () { t.classList.remove('visible'); }, 2200);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#bag-toggle')) {
      var d = document.getElementById('bag-dialog');
      if (d && d.showModal) d.showModal();
      fetchCart();
    }
    if (e.target.closest('[data-close]')) {
      var dlg = e.target.closest('dialog');
      if (dlg) dlg.close();
    }
    var removeBtn = e.target.closest('[data-remove-key]');
    if (removeBtn) {
      changeCart(removeBtn.dataset.removeKey, 0).then(fetchCart);
    }
  });

  $$('dialog').forEach(function (d) {
    d.addEventListener('click', function (e) {
      if (e.target === d) {
        var r = d.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) d.close();
      }
    });
  });

  /* ---------------- Product page ---------------- */
  var COLOR_HEX = {
    white: '#f5f5f3', black: '#141414', apricot: '#f4c9a0', graygreen: '#9aa08c',
    darkgray: '#4a4a4a', navy: '#1b2a4a', blackishgreen: '#1f3327', carbongray: '#3a3a3a',
    brown: '#5b3a29', watermelonred: '#e2637a', graycamel: '#b3a186', yellow: '#f0da6d',
    sandcolor: '#d8c7a5', oatgray: '#cfc9bd', milktea: '#e7d8c4', blue: '#6f93c9', gray: '#8c8c8c',
    charcoal: '#333333', sandbeige: '#ddceac', creamivory: '#f2ecdd', coralpink: '#e28a7b',
    forestgreen: '#1f4023', sageolivegreen: '#a3a887', ashheathergray: '#d3d2ce',
    stonetaupe: '#a89e8c', darkbrowncoffee: '#3d2a1d', paleyellow: '#f2e6a8'
  };
  function swatchHex(name) {
    var key = (name || '').toLowerCase().replace(/[^a-z]/g, '');
    return COLOR_HEX[key] || '#c9c6bf';
  }

  var sizeWrap = document.getElementById('sizes');
  var colorWrap = document.getElementById('colors');
  if (sizeWrap) {
    var form = document.getElementById('product-form');
    var input = document.getElementById('selected-variant-id');
    var addBtn = document.getElementById('add-bag');
    var colorLabel = document.getElementById('selected-color-label');
    var variantDataEl = document.getElementById('variant-data');
    var variants = null;
    if (variantDataEl) {
      try { variants = JSON.parse(variantDataEl.textContent); } catch (e) { variants = null; }
    }

    if (variants && colorWrap) {
      /* ---- Separate color + size selectors ---- */
      var selectedColor = null;
      var selectedSize = null;
      var colorButtons = $$('[data-color]', colorWrap);
      var sizeButtons = $$('[data-size]', sizeWrap);

      colorButtons.forEach(function (b) {
        var dot = b.querySelector('.swatch-dot');
        if (dot) dot.style.background = swatchHex(b.dataset.color);
      });

      function availableSizesFor(color) {
        var set = {};
        variants.forEach(function (v) {
          if (v.color === color && v.available) set[v.size] = true;
        });
        return set;
      }

      function findVariant(color, size) {
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].color === color && variants[i].size === size) return variants[i];
        }
        return null;
      }

      function updateImages(color) {
        var gallery = document.getElementById('detail-gallery');
        if (!gallery) return;
        var imgs = $$('.gallery-image', gallery);
        if (!imgs.length) return;
        var matched = imgs.filter(function (im) { return im.dataset.color === color; });
        var visible = matched.length ? matched : imgs;
        imgs.forEach(function (im) { im.hidden = visible.indexOf(im) === -1; });
        gallery.scrollTop = 0;
      }

      function updateAddButton() {
        if (!selectedColor) { addBtn.disabled = true; addBtn.textContent = 'SELECT A COLOR'; input.value = ''; return; }
        if (!selectedSize) { addBtn.disabled = true; addBtn.textContent = 'SELECT A SIZE'; input.value = ''; return; }
        var variant = findVariant(selectedColor, selectedSize);
        if (!variant || !variant.available) { addBtn.disabled = true; addBtn.textContent = 'SOLD OUT'; input.value = ''; return; }
        addBtn.disabled = false;
        addBtn.textContent = 'SAVE TO BAG ↗';
        input.value = variant.id;
      }

      function refreshSizeButtons() {
        var avail = selectedColor ? availableSizesFor(selectedColor) : null;
        sizeButtons.forEach(function (b) {
          var size = b.dataset.size;
          b.disabled = avail ? !avail[size] : false;
          var selected = b.dataset.size === selectedSize;
          b.classList.toggle('selected', selected);
          b.setAttribute('aria-pressed', String(selected));
        });
      }

      colorWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-color]');
        if (!btn) return;
        selectedColor = btn.dataset.color;
        colorButtons.forEach(function (b) {
          var sel = b === btn;
          b.classList.toggle('selected', sel);
          b.setAttribute('aria-pressed', String(sel));
        });
        if (colorLabel) colorLabel.textContent = selectedColor ? '— ' + selectedColor : '';
        if (selectedSize) {
          var avail = availableSizesFor(selectedColor);
          if (!avail[selectedSize]) selectedSize = null;
        }
        refreshSizeButtons();
        updateImages(selectedColor);
        updateAddButton();
      });

      sizeWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-size]');
        if (!btn || btn.disabled) return;
        selectedSize = btn.dataset.size;
        refreshSizeButtons();
        updateAddButton();
      });

      refreshSizeButtons();
      updateAddButton();

      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!input.value) return;
          addBtn.disabled = true;
          addToCart(input.value)
            .then(function () {
              fetchCart();
              toast('Saved to your bag');
              var d = document.getElementById('bag-dialog');
              if (d && d.showModal) d.showModal();
            })
            .catch(function () { toast('Could not add to bag'); })
            .finally(function () { updateAddButton(); });
        });
      }
    } else {
      /* ---- Fallback: flat variant list (no separate color/size options) ---- */
      var formFallback = document.getElementById('product-form');
      var inputFallback = document.getElementById('selected-variant-id');
      var addBtnFallback = document.getElementById('add-bag');

      sizeWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-variant-id]');
        if (!btn || btn.dataset.available === 'false') return;
        $$('[data-variant-id]', sizeWrap).forEach(function (b) {
          var selected = b === btn;
          b.classList.toggle('selected', selected);
          b.setAttribute('aria-pressed', String(selected));
        });
        inputFallback.value = btn.dataset.variantId;
        addBtnFallback.disabled = false;
        addBtnFallback.textContent = 'SAVE TO BAG ↗';
      });

      if (formFallback) {
        formFallback.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!inputFallback.value) return;
          addBtnFallback.disabled = true;
          addToCart(inputFallback.value)
            .then(function () {
              fetchCart();
              toast('Saved to your bag');
              var d = document.getElementById('bag-dialog');
              if (d && d.showModal) d.showModal();
            })
            .catch(function () { toast('Could not add to bag'); })
            .finally(function () { addBtnFallback.disabled = false; });
        });
      }
    }
  }

  fetchCart();
})();

/* ---------------- Free shipping progress bar ---------------- */
(function () {
  var bar = document.getElementById('shipping-bar');
  if (!bar) return;
  var fill = document.getElementById('shipping-bar-fill');
  var threshold = parseFloat(bar.dataset.threshold || '0') * 100;
  var progressCopy = bar.dataset.copy || '';
  var successCopy = bar.dataset.success || '';

  function update() {
    if (!threshold) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var pct = Math.min(100, (cart.total_price / threshold) * 100);
        if (fill) fill.style.width = pct + '%';
        var remaining = threshold - cart.total_price;
        var moneyStr;
        try {
          moneyStr = new Intl.NumberFormat('en-US', { style: 'currency', currency: cart.currency || 'USD' }).format(Math.max(0, remaining) / 100);
        } catch (e) {
          moneyStr = '$' + (Math.max(0, remaining) / 100).toFixed(2);
        }
        bar.textContent = remaining > 0 ? progressCopy.replace('{{ amount }}', moneyStr) : successCopy;
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#bag-toggle')) update();
  });
  document.addEventListener('submit', function (e) {
    if (e.target && e.target.id === 'product-form') setTimeout(update, 400);
  });
  update();
})();

/* ---------------- Scroll-in reveal ---------------- */
(function () {
  if (!('IntersectionObserver' in window)) return;
  var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
})();

/* ---------------- Sticky add-to-cart (PDP) ---------------- */
(function () {
  var bar = document.getElementById('sticky-atc');
  var anchor = document.getElementById('add-bag');
  if (!bar || !anchor) return;
  var barBtn = bar.querySelector('button');

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(anchor);
  }

  if (barBtn) {
    barBtn.addEventListener('click', function () { anchor.click(); });
  }
})();

/* ---------------- Drop countdown ---------------- */
(function () {
  var el = document.querySelector('[data-countdown]');
  if (!el) return;
  var target = new Date(el.dataset.countdown).getTime();
  if (isNaN(target)) return;
  var dEl = el.querySelector('[data-d]');
  var hEl = el.querySelector('[data-h]');
  var mEl = el.querySelector('[data-m]');
  var sEl = el.querySelector('[data-s]');

  function pad(n) { n = String(n); return n.length < 2 ? '0' + n : n; }

  function tick() {
    var diff = target - Date.now();
    if (diff <= 0) { el.hidden = true; return; }
    var d = Math.floor(diff / 86400000);
    var h = Math.floor((diff % 86400000) / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    if (dEl) dEl.textContent = pad(d);
    if (hEl) hEl.textContent = pad(h);
    if (mEl) mEl.textContent = pad(m);
    if (sEl) sEl.textContent = pad(s);
  }
  tick();
  setInterval(tick, 1000);
})();
